/**
 * @generated SignedSource<<35b95116fc84f44baa811fc41e509ea0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contributionsCount"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "participativeModuleSlug"
},
v2 = [
  {
    "kind": "Variable",
    "name": "participativeModuleSlug",
    "variableName": "participativeModuleSlug"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contributionsCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iconClass",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryColor",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryContrastColor",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reactionsCount",
  "storageKey": null
},
v13 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "contributionsCount"
  }
],
v14 = {
  "alias": null,
  "args": (v13/*: any*/),
  "concreteType": "ContributionConnection",
  "kind": "LinkedField",
  "name": "contributions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContributionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Contribution",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v12/*: any*/),
            (v6/*: any*/),
            (v3/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endCursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasNextPage",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": (v13/*: any*/),
  "filters": null,
  "handle": "connection",
  "key": "ContributionsDatavizGraphAnimation_contributions",
  "kind": "LinkedHandle",
  "name": "contributions"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ContributionsDatavizGraphRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "participativeModule",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContributionsDatavizGraph_participativeModule"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContributionsDatavizGraphRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "participativeModule",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ParticipativeModuleAuthorizations",
                "kind": "LinkedField",
                "name": "authorizations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contributionsDisplayAuthorized",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "visualization",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "enableListViewOnFirstPage",
                        "storageKey": null
                      }
                    ],
                    "type": "ContributionsDataviz",
                    "abstractKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Theme",
                "kind": "LinkedField",
                "name": "themes",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v6/*: any*/),
                      (v4/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v5/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Theme",
                        "kind": "LinkedField",
                        "name": "children",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v14/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  (v4/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v5/*: any*/),
                  (v12/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "ParticipativeModule",
            "abstractKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9a2f9a75a802c5e1c1c9d352d5f6979d",
    "id": null,
    "metadata": {},
    "name": "ContributionsDatavizGraphRouteQuery",
    "operationKind": "query",
    "text": "query ContributionsDatavizGraphRouteQuery(\n  $participativeModuleSlug: ID!\n  $contributionsCount: Int!\n) {\n  participativeModule(participativeModuleSlug: $participativeModuleSlug) {\n    __typename\n    ...ContributionsDatavizGraph_participativeModule\n    id\n  }\n}\n\nfragment ContributionsDatavizGraphAnimation_participativeModule on ParticipativeModule {\n  slug\n  themes {\n    id\n    slug\n    name\n    iconClass\n    description\n    contributionsCount\n    reactionsCount\n    primaryColor\n    primaryContrastColor\n    contributions(first: $contributionsCount) {\n      edges {\n        node {\n          reactionsCount\n          id\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    children {\n      id\n      slug\n      name\n      iconClass\n      description\n      contributionsCount\n      reactionsCount\n      primaryColor\n      primaryContrastColor\n      children {\n        id\n      }\n      contributions(first: $contributionsCount) {\n        edges {\n          node {\n            reactionsCount\n            id\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n}\n\nfragment ContributionsDatavizGraph_participativeModule on ParticipativeModule {\n  ...ContributionsDatavizRootLayout_participativeModule\n  ...ContributionsDatavizGraphAnimation_participativeModule\n}\n\nfragment ContributionsDatavizMainContainerHeader_participativeModule on ParticipativeModule {\n  ...ContributionsDatavizViewModeSwitch_participativeModule\n}\n\nfragment ContributionsDatavizRootLayout_participativeModule on ParticipativeModule {\n  title\n  slug\n  contributionsCount\n  authorizations {\n    contributionsDisplayAuthorized\n  }\n  ...ContributionsDatavizTabs_participativeModule\n  ...ContributionsDatavizThemesNavigation_participativeModule\n  ...ContributionsDatavizMainContainerHeader_participativeModule\n}\n\nfragment ContributionsDatavizTabs_participativeModule on ParticipativeModule {\n  slug\n  visualization {\n    __typename\n    ... on ContributionsDataviz {\n      enableListViewOnFirstPage\n    }\n    id\n  }\n}\n\nfragment ContributionsDatavizThemeMeasures_theme on Theme {\n  contributionsCount\n  reactionsCount\n}\n\nfragment ContributionsDatavizThemesNavigationTheme_participativeModule on ParticipativeModule {\n  slug\n}\n\nfragment ContributionsDatavizThemesNavigationTheme_theme on Theme {\n  description\n  children {\n    id\n    slug\n    name\n    iconClass\n    primaryColor\n    primaryContrastColor\n  }\n  id\n  slug\n  name\n  iconClass\n  primaryColor\n  primaryContrastColor\n  ...ContributionsDatavizThemeMeasures_theme\n}\n\nfragment ContributionsDatavizThemesNavigation_participativeModule on ParticipativeModule {\n  ...ContributionsDatavizThemesNavigationTheme_participativeModule\n  themes {\n    id\n    children {\n      __typename\n      id\n    }\n    ...ContributionsDatavizThemesNavigationTheme_theme\n  }\n}\n\nfragment ContributionsDatavizViewModeSwitch_participativeModule on ParticipativeModule {\n  slug\n}\n"
  }
};
})();

node.hash = "048f0ae934f6804c79eca7c86b3e2aff";

module.exports = node;
